import { PublicChildOccurrence, PublicOccurrence } from '@cademy-package/sdk-component-types';

export const isChildOccurrence = (
    occurrence: PublicOccurrence
): occurrence is PublicChildOccurrence => {
    return 'parent_ref' in occurrence && typeof occurrence.parent_ref === 'string';
};
